// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8213dbcf","455":"f86f246f","977":"80b90248"}[chunkId] + ".chunk.js";
};